import { memo as ReactMemo } from 'react';

export const memo: <T>(component: T) => T = ReactMemo;
